export function PlatformCode({ code }: { code: string }) {
  return (
    <span className="inline-grid h-[18px] min-w-[26px] flex-none place-items-center rounded bg-surface-3 px-1 font-mono text-2xs font-semibold text-muted">
      {code}
    </span>
  );
}
